module.exports = __webpack_public_path__ + "img/29.09ccc972.png";